import axios from 'axios'
import store from '../store'
// import router from '../router'
// import { Base64 } from 'js-base64'
// import URLSearchParams from 'url-search-params'
import qs from 'qs'
axios.defaults.timeout = 100000
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // console.log(config, 888)
    if (!config.headers['Content-Type']) {
      config.data = JSON.stringify(config.data)
      config.headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
    if (store.getters.token) {
      config.headers.Authorization = store.getters.token
    }
    return config
  }
)

// 返回状态判断
axios.interceptors.response.use(
  res => {
    console.log(res)
    console.log(res.status, '请求失败的返回值')
    if (res.status !== 200) {
      return Promise.reject(res)
    }
    return res.data
  },
  error => {
    if (!navigator.onLine) {
      alert('请检查您的网络！')
      return
    }
    return Promise.reject(error)
  }
)

// 封装get方法
export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 封装post请求

export function post (url, data = {}, config) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

// 封装patch请求
export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

// 封装put请求

export function put (url, data = {}) {
  axios.defaults.headers['Content-Type'] = 'application/json'
  return new Promise((resolve, reject) => {
    axios.put(url, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

// 封装delete请求

export function del (url, params = {}, isJSON = true) {
  const data = {
    data: params
  }
  if (!isJSON) {
    axios.defaults.headers['Content-Type'] = 'application/json'
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}
